import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiSubscription } from "@/services/api-client/subscriptions";

import { subscriptionsKeys } from "./subscriptions.keys";

export const useUnsubscribeUserMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (subscriptionId: string) =>
      apiSubscription.unsubscribeUser(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: subscriptionsKeys.all });
    },
  });
};
